var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',_vm._l((_vm.powerData),function(ref){
var name = ref.name;
var description = ref.description;
var text = ref.text;
return _c('LinkModal',{key:name,attrs:{"link":text}},[_c('VueMarkdown',{attrs:{"source":description.replace(/�/g, ' - ')}})],1)}),1)}
var staticRenderFns = []

export { render, staticRenderFns }